import React from "react";
import {Link} from "react-router-dom";
import solutions from "./ServicesData";
import { FaArrowTrendUp } from "react-icons/fa6";
import "./Solutions.css";


const SolutionSection1 = () => {
return (
<section className="backdiv">
<h2 className="main-title">Innovative Technology Solutions<br/>Built For Business Growth</h2>

<div className="solution-container">
{
solutions.map((item)=>(
<div className="solution-card">
<div className="icon-box">
<p> {item.icon}</p>
</div>

<div>
<h3 className="sol-card-head">{item.title}</h3>
<p className="sol-card-text">{item.description}</p>

<Link to={item.link}
className="learn-btn">Explore Solution <FaArrowTrendUp />
</Link>
</div>

</div>

))
}
</div>
</section>
)
}


export default SolutionSection1;